import Webcam from 'react-webcam';
import { CameraOptions, useFaceDetection } from 'react-use-face-detection';
import FaceDetection from '@mediapipe/face_detection';
import { Camera } from '@mediapipe/camera_utils';
import { useContext, useEffect } from 'react';
import { ContextApi } from '../../App';
import { toast } from 'react-toastify';
import { Paper, Typography, useMediaQuery, useTheme } from '@mui/material';

function WebcamDemo({ getTotalFaces }) {
  document.body.style.backgroundColor = 'rgb(224, 225, 221)';
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const width = isSmallScreen ? 240 : isMediumScreen ? 510 : isLargeScreen ? 600 : 690;
  const height = isSmallScreen ? 180 : isMediumScreen ? 380 : isLargeScreen ? 430 : 520;
  const { totalFaces, setTotalFaces } = useContext(ContextApi);
  const { webcamRef, boundingBox, isLoading, detected, facesDetected } = useFaceDetection({
    faceDetectionOptions: {
      model: 'short'
    },
    faceDetection: new FaceDetection.FaceDetection({
      locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/${file}`
    }),
    camera: ({ mediaSrc, onFrame }) =>
      new Camera(mediaSrc, {
        onFrame,
        width,
        height
      })
  });
  const sendCameraError = (faces) => {
    if (faces == 0) {
      toast.error(`Error`, {
        position: toast.POSITION.TOP_RIGHT,
        toastId: 'error1'
      });
    } else if (faces > 1) {
    }
  };

  useEffect(() => {
    // sendCameraError(facesDetected)
    setTotalFaces(facesDetected);
  }, [facesDetected]);
  return (
    <>
      <Paper
        elevation={3}
        style={{
          maxWidth: '750px',
          margin: 'auto',
          marginTop: '20px',
          padding: '20px',
          borderRadius: '15px',
          backgroundColor: 'white',
          border: '2px solid rgb(200, 200, 200)',
          textAlign: 'center'
        }}
      >
        <Typography></Typography>
        <div style={{ width, height, margin: 'auto', position: 'relative' }}>
          {boundingBox.map((box, index) => (
            <div
              key={`${index + 1}`}
              style={{
                border: '2px dashed rgb(25, 118, 210)',
                borderRadius: '8px',
                position: 'absolute',
                top: `${box.yCenter * 100}%`,
                left: `${box.xCenter * 100}%`,
                width: `${box.width * 100}%`,
                height: `${box.height * 100}%`,
                zIndex: 1,
                boxShadow: '0px 0px 10px rgba(25, 118, 210, 0.5)'
              }}
            />
          ))}
          <Webcam
            ref={webcamRef}
            forceScreenshotSourceSize
            style={{
              width,
              height,
              // border: '2px solid black  ',
              borderRadius: '10px',
              boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)'
            }}
          />
        </div>
        <Typography
          variant="body2"
          style={{
            marginTop: '10px',
            color: detected ? 'green' : 'red'
          }}
        >
          {detected ? `Face detected: ${facesDetected}` : 'No face detected'}
        </Typography>
      </Paper>
    </>
  );
}

export default WebcamDemo;
